<div class="container-fluid bg-white">
  <div class="row">
    <div class="col-12 d-flex flex-column align-items-center justify-content-center" style="height: 100vh">
      <img src="images/splash-logo.gif" alt="Logo" class="temp-log" loading="eager" />
    </div>
  </div>
</div>